exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".myreport-item .session-sub-header {\r\n    float: right;\r\n    margin-bottom: -20px;\r\n    margin-top: -5px;\r\n}\r\n.myreport-item .session-sub-header li:last-child {\r\n    margin-right: 0;\r\n}\r\n\r\n.myreport-table .dataTables_wrapper {\r\n    max-height: 525px;\r\n}\r\n\r\n/* table{\r\n      display: block;\r\n      height: calc(100vh - 4.2rem - 4.2rem - 4.2rem + 1.29rem)\r\n  } */\r\n\r\nvirtual-scroll {\r\n  overflow: hidden;\r\n  overflow-y: auto;\r\n  height: 50vh;\r\n  display: block;\r\n}\r\n/* table {\r\n    overflow: hidden;\r\n    width: 100%;\r\n    \r\n    display: block;\r\n\r\n  }\r\n  td {\r\n    padding: .5rem;\r\n  } */\r\n/* tr {\r\n    width: 90px;\r\n} */\r\n\r\n.table-wrapper {\r\n  overflow-y: auto;\r\n  /* overflow: hidden !important; */\r\n  height: 50vh !important;\r\n}\r\n\r\n/* table {\r\n  overflow: hidden;\r\n  width: 100%;\r\n  display: block;\r\n} */\r\n\r\n/* td {\r\n  padding-top: 0 !important;\r\n} */\r\n.virtual-scroll-data-table {\r\n  display: block;\r\n  width: 100%;\r\n  height: 30vh;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/users/users.component.css
// module id = ../../../../../src/app/reports/myReports/users/users.component.css
// module chunks = main